import { Environment } from '../common/types';

const uikitWithVersion = 'https://uikit.developers.rio.cloud/2.5.1';

export const loadTheme = (environment: Environment) => {
    const cssThemeProvider = environment === Environment.RIO ? 'rio' : 'vw';
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `${uikitWithVersion}/${cssThemeProvider}-uikit.css`;
    document.head.appendChild(link);
};
